var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orientation"},[_c('div',{staticClass:"orientation-inner"},[_c('i',{style:(_vm.orientationImage)}),_c('span',[_vm._v(_vm._s(_vm.$t('orientationTxt.txt')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }